import { render } from "./ProgramAssessments.vue?vue&type=template&id=40551e4c"
import script from "./ProgramAssessments.vue?vue&type=script&lang=js"
export * from "./ProgramAssessments.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__